var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "relative flex flex-col gap-2 py-3 pl-10 pr-3 border rounded min-h-24 bg-pure-white border-slate-400",
      attrs: { id: "instruction_stage_" + _vm.instruction.id }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "absolute flex flex-col items-center justify-between flex-shrink-0 py-3 rounded-l w-7",
          style: {
            height: "calc(100% + 2px)",
            top: "-1px",
            left: "-1px",
            background: "linear-gradient(180deg, #F9FCE9 0%, #EEFDB1 100%)"
          }
        },
        [
          _vm.instruction.instruction_type === "notes"
            ? _c(
                "div",
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    attrs: { icon: "paper-note", color: "lime-6" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.instruction.instruction_type === "todo"
            ? _c("div", [
                _c("input", { attrs: { type: "checkbox", name: "", id: "" } })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editable
            ? _c(
                "div",
                {
                  staticClass:
                    "h-5.5 w-5.5 flex items-center justify-center rounded hover:bg-lime-400 cursor-pointer",
                  on: {
                    click: function($event) {
                      _vm.editOpened = true
                    }
                  }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    attrs: { icon: "edit", color: "lime-6" }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col gap-1" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-between gap-2 cursor-pointer",
            on: {
              click: function($event) {
                _vm.chevronOpened = !_vm.chevronOpened
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "flex truncate",
                attrs: { title: _vm.instruction.title }
              },
              [
                _c("BlTextSubtitle3", {
                  staticClass: "truncate",
                  attrs: { text: _vm.instruction.title }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.showIcon
              ? _c("BlIcon", {
                  staticClass: "w-5 h-5 transition-all duration-300",
                  style: { rotate: _vm.chevronOpened ? "180deg" : "" },
                  attrs: { icon: "chevron-down" }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }, [
          _c("div", {
            staticClass: "text-sm whitespace-pre-line text-slate-700",
            class: { "line-clamp-2": !_vm.chevronOpened },
            domProps: { innerHTML: _vm._s(_vm.instruction.description) }
          })
        ]),
        _vm._v(" "),
        _vm.chevronOpened && _vm.instruction.documents.length
          ? _c(
              "div",
              { staticClass: "flex flex-col gap-2 p-2 rounded bg-slate-200" },
              _vm._l(_vm.instruction.documents, function(doc, idx) {
                return _c("BlFileHolder", {
                  key: idx,
                  attrs: {
                    name: doc.blob.filename,
                    size: doc.blob.byte_size,
                    url: doc.file_url
                  }
                })
              }),
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("EditInstructionStagePanel", {
        attrs: {
          open: _vm.editOpened,
          instruction: _vm.instruction,
          stage: _vm.stage
        },
        on: {
          "close-panel": function($event) {
            _vm.editOpened = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-035e4fc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035e4fc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/pipeline/InstructionStage.vue
// module id = null
// module chunks = 